import React from 'react';

export const FileIcon = props => {
  return (
    <span className="solstice-icon- solstice-icon-file" style={props.style} />
  );
};
